module.exports = __webpack_public_path__ + "Huawei_P20.svg?b438139f49f46415246fc0a6775cb612";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Huawei_P20.svg
// module id = 195
// module chunks = 0